import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload a campaign to multiple products.
 *
 * @param {{
 *  referenceIds: string[],
 *  productTypeIds: number[],
 *  sourceId: number,
 *  siteId: number
 * }}
 * @param {string[]} referenceIds Product Ids
 * @param {number[]} productTypeIds Product Types Ids
 * @param {number} sourceId Source Id
 * @param {number} siteId Site Id
*/
export default function postProductTypesPluId({
  referenceIds,
  productTypeIds,
  sourceId,
  siteId,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/product-types/plu-id/${sourceId}`;

  const body = {
    referenceIds,
    productTypeIds,
    siteId,
  };

  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Product Typess', 'Started : Product Types : PLU (Update)')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
